import React, { useState } from "react";
import emailjs from "emailjs-com";
import { useForm } from "react-hook-form";

const Contact = () => {
  const [successMessage, setSuccessMessage] = useState();
  const { register, handleSubmit, errors } = useForm();

  const onSubmit = (data, reset) => {
    sendEmail(
      serviceID,
      templateID,
      {
        name: data.name,
        phone: data.phone,
        email: data.email,
        subject: data.subject,
        description: data.description,
      },
      userID
    );
    reset.target.reset();
  };

  const serviceID = "service_ID";
  const templateID = "template_ID";
  const userID = "user_P7RXZprkTeROy1FKSNvti";

  const sendEmail = (serviceID, templateID, variables, userID) => {
    emailjs
      .send(serviceID, templateID, variables, userID)
      .then(() => {
        setSuccessMessage("Form Sent Successfully!");
      })
      .catch((error) =>
        console.error(`Something doesn't seem right. ${error}`)
      );
  };

  return (
    <div id="contact" className="contact">
      <div className="text-center">
        <h1>Contact Me</h1>
        <p>
          Send me a message if you're interested in working with me or write a
          review of my services.
        </p>
        <span className="success-message">{successMessage}</span>
      </div>
      <div className="container">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-md-6 col-xs-12">
              <div className="text-center">
                <input
                  className="form-control"
                  placeholder="Name"
                  name="name"
                  type="text"
                  ref={register({
                    required: "Name is required.",
                    maxLength: {
                      value: 20,
                      message: "Name must be fewer than 20 characters.",
                    },
                  })}
                />
                <span className="error-message">
                  {errors.name && errors.name.message}
                </span>
                <div className="line"></div>
              </div>
              <div className="text-center">
                <input
                  className="form-control"
                  placeholder="Phone Number"
                  name="phone"
                  type="tel"
                  ref={register({
                    required: "Phone is required.",
                    pattern: {
                      value:
                        /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im,
                    },
                  })}
                  maxLength="12"
                />
                <span className="error-message">
                  {errors.phone && errors.phone.message}
                </span>
                <div className="line"></div>
              </div>
              <div className="text-center">
                <input
                  className="form-control"
                  placeholder="Email"
                  name="email"
                  type="email"
                  ref={register({
                    required: "Email is required.",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "Invalid email.",
                    },
                  })}
                />
                <span className="error-message">
                  {errors.email && errors.email.message}
                </span>
                <div className="line"></div>
              </div>
              <div className="text-center">
                <input
                  className="form-control"
                  placeholder="Subject"
                  name="subject"
                  type="text"
                  ref={register({
                    required: "Subject is required.",
                  })}
                />
                <span className="error-message">
                  {errors.subject && errors.subject.message}
                </span>
                <div className="line"></div>
              </div>
            </div>
            <div className="col-md 6 col-xs-12">
              <div className="text-center">
                <textarea
                  className="form-control"
                  placeholder="Short Description of Project"
                  name="description"
                  type="text"
                  ref={register({
                    required: "Short Description is required.",
                  })}
                />
                <span className="error-message">
                  {errors.description && errors.description.message}
                </span>
                <div className="line"></div>
              </div>
            </div>
          </div>
          <div className="text-center">
            <button className="btn-main-offer contact-btn" type="submit">
              Contact Me
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Contact;
